import React from 'react';
import { connect } from 'react-redux';
import AppLayout from '../AppLayout';
import { Link, withRouter } from 'react-router-dom';
import { deleteGenerator, generatroPDF, listGenerator } from '../../Api';

import moment from 'moment';

import InputText from '../InputText';
import TableLotto from '../TableLotto';

class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: moment().format('YYYY-MM-DD'),
      cifras: 1,
      opciones: 1,
      error: {},
      loader: false
    }
    this.readyDashboard = this.readyDashboard.bind(this);
    this.okRemoveLottery = this.okRemoveLottery.bind(this);
    this.errorRemoveLottery = this.errorRemoveLottery.bind(this);
    this.readyFindLotto = this.readyFindLotto.bind(this);
  }

  readyDashboard() {
    listGenerator({
      token: this.props.usuario.token,
      params: { date: this.state.startDate }
    }).then(data => {
      this.setState({
        generators: data,
        loader: false
      })
    })
  }

  okRemoveLottery(event, data) {
    this.reload()
  }
  errorRemoveLottery(event, data) {
    alert('Algo paso, intenta nuevamente \n' + JSON.stringify(data))
  }

  componentDidMount() {
    this.setState({ loader: true })
    this.reload()
    this.readyDashboard()
  }

  componentWillUnmount() {

  }

  reload() {
    this.readyDashboard()
  }

  readyFindLotto(event, { files, err }) {
    this.setState({ loader: false })
    if (err) {
      alert(JSON.stringify(err))
      return 0
    }
    let text = 'Archivos creados: \n'
    for (let index = 0; index < files.length; index++) {
      const name = files[index];
      text += `${name}\n`;
    }
    alert(text)
  }

  render() {
    const { startDate, error, generators } = this.state;
    return (
      <AppLayout title={"Archivos"}>
        <div className="row">
          <div className="col-md-3">
            <InputText
              value={startDate}
              error={error.startDate}
              placeholder={""}
              label={"Fecha sorteo"}
              onChange={(event) => { this.setState({ "startDate": event.target.value }) }}
              type={"date"}
            />
          </div>
          <div className="col-md-3">
            <button
              className="btn btn-primary btn-flat btn-sm"
              onClick={(event) => { this.reload() }}
            >
              Buscar
            </button>
            <Link
              to={`generators/new`}
              className="btn btn-primary btn-flat btn-sm"
            >Nuevo</Link>
          </div>
        </div>
        <TableLotto
          data={generators}
          loader={this.state.loader}
          onRemove={(data) => {
            // eslint-disable-next-line no-restricted-globals
            const ok = confirm("Seguro quieres borrar este documento?");
            if (ok) {
              this.setState({ loader: true })
              deleteGenerator(data._id, this.props.usuario.token).then(data => {
                this.setState({ loader: false })
                this.readyDashboard()
              }).catch(error => {
                this.setState({ loader: false })
                alert('Algo no esta bien. ' + error)
              })
            }
          }}
          onPDF={(data, color) => {
            this.setState({ loader: true })
            generatroPDF({ id: data._id, color, token: this.props.usuario.token })
              .then(data => {
                console.log({ data })
                this.setState({ loader: false })
              }).catch(error => {
                this.setState({ loader: false })
                alert('Algo no esta bien. ' + error)
              })
          }}
        />
      </AppLayout>
    )
  }
};

const mapStoreToProps = (state, props) => {
  return {
    ...props,
    usuario: state.usuario,
    lotteries: state.lotteries,
    marketplaces: state.marketplaces
  }
}
export default withRouter(connect(mapStoreToProps)(Dashboard));